// src/components/TrainerDashboard/TrainerAthleteView.js
import { useTranslation } from '../../i18n';
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AthleteDashboard from '../AthleteDashboard/AthleteDashboard';

const TrainerAthleteView = () => {
  const { t } = useTranslation();
  const { athleteId } = useParams();
  const navigate = useNavigate();

  if (!athleteId) return <p>{t("common.userNotFound")}</p>;

  return (
    <div>
      <button
        onClick={() => navigate('/trainer-dashboard')}
        className="btn btn-secondary m-3"
      >
        ← Volver al Dashboard del Entrenador
      </button>

      <AthleteDashboard isTrainerView={true} athleteId={athleteId} />
    </div>
  );
};

export default TrainerAthleteView;
